import ApolloClient from "apollo-client";
import { NormalizedCacheObject } from "apollo-cache-inmemory";

import { LuxSEGatewayGraphQLClientFactory } from "../lib/LuxSEGatewayGraphQLClientFactory";
import config from "../temp/config";

export const luxseGatewayGraphqlClient: ApolloClient<NormalizedCacheObject> =
  LuxSEGatewayGraphQLClientFactory(process.env.LUXSE_GRAPHQL_SCHEMA_ENDPOINT || config.luxSEGatewayGraphQLEndpoint);
